import { makeStyles } from "@fluentui/react-components";
import { Checkmark20Regular, Dismiss20Regular } from "@fluentui/react-icons";
import { ICheckboxIndicatorProps } from "./checkbox-indicator.props";

const layoutStyles = makeStyles({
    checkboxRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '8px'
    }
});

/**
 * Reusable component for displaying a checkbox indicator with checkmark or dismiss icon
 * Used in report summaries to show boolean settings
 */
export default function CheckboxIndicator(props: ICheckboxIndicatorProps) {
    const styles = layoutStyles();

    return (
        <div className={styles.checkboxRow}>
            {props.checked ? (
                <Checkmark20Regular />
            ) : (
                <Dismiss20Regular />
            )}
            <span>{props.label}</span>
        </div>
    );
}
